export const app = {
  NAME: 'Celestia Nebula',
  VERSION: '2025.07.1901',
  UPDATE_DATE: 'Jul 19, 2025',
  Dependencies: {
    Celestia: '1.0',
  },
}
